// extracted by mini-css-extract-plugin
export var footer = "_mp-5";
export var fulfillmentInput = "_mp-0";
export var shipDateInput = "_mp-1";
export var shipmentModal = "_mp-2";
export var shipmentModalContent = "_mp-3";
export var tableContainer = "_mp-4";